"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given value is a real boolean.
 *
 * @export
 * @class IsBooleanValidator
 * @implements {PropertyValidator<any>}
 */
class IsBooleanValidator {
    isValid(input) {
        return input instanceof Boolean || typeof input === "boolean";
    }
}
exports.IsBooleanValidator = IsBooleanValidator;
//# sourceMappingURL=IsBooleanValidator.js.map